import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SIGN_FORM_LAST_NAME_INITIAL = defineFcm('sign_form_last_name_initial')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean', optional: true },
			},
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Page',
		description:
			'Runtime kill switch for the sign_form_last_name_initial_experiment. When disabled the ' +
			'experiment resolves to control with fallbackReason "disabled" and the recently signed carousel ' +
			'keeps rendering full names. Scope is not configurable here — the carousel only renders in the ' +
			'mobile sign modal, so the surface itself defines the audience.',
		import: false,
		// `enabled: true`, not false. `withDefault({ enabled: false })` already protects production before the
		// config exists, so creating it in the admin is the deliberate act of turning the experiment on. A
		// template pre-filled `false` makes that a silent no-op — the operator reports the experiment live
		// while every session resolves `fallbackReason: 'disabled'`.
		template: { enabled: true },
	});
